let choice = {
    hand:[
        {
            id:0,
            title:"퍼퓸 쉘 엑스 카모",
            imgUrl:"/img/hand.jpg",
            content:"진득한 카모마일 | 부드러운 나무결 | 머스크",
            price:32000
        },
    
        {
            id:1,
            title:"퍼퓸 쉘 엑스 버가샌달",
            imgUrl:"/img/hand2.jpg",
            content:"지중해의 베르가못 | 쌉사래한 청귤 | 샌달우드",
            price:32000
        },
    
        {
            id:2,
            title:"퍼퓸 쉘 엑스 라레",
            imgUrl:"/img/hand3.jpg",
            content:"이슬을 머금은 풋사과 | 화이트 튤립 | 샌달우드",
            price:32000
        },
    
        {
            id:3,
            title:"FEY9",
            imgUrl:"/img/hand14.jpg",
            content:"무화과 나무 | 엠브레트 씨앗 | 달콤 씁쓸한",
            price:32000
        }
    
    ],
    candle:[
        {
            id:0,
            title:"SOUNDS OF NIGHT",
            imgUrl:"/img/candle5.jpg",
            content:"씁쓸한 프루티함 | 바람에 흔들리는 꽃의 향 | 고요함",
            price:28900
        },
    
        {
            id:1,
            title:"MULBERRY LEAVES",
            imgUrl:"/img/candle6.jpg",
            content:"회귀의 향 | 나무껍질의 눈물 | 내적 평온",
            price:28900
        },
    
        {
            id:2,
            title:"COCOON MUSK",
            imgUrl:"/img/candle7.jpg",
            content:"패츌리 | 쌉사래한 풀 줄기 | 스모키함",
            price:28900
        },
    
        {
            id:3,
            title:"CONCRETE BOOK STORE",
            imgUrl:"/img/candle10.jpg",
            content:"하우스 도산 익스클루시브",
            price:28900
        }
    
    ],
    gift:[
        {
            id:0,
            title:"퍼퓸핸드 미니 듀오 세트 베스트(FEY9+VEIN)",
            imgUrl:"/img/gift.jpg",
            content:"퍼퓸핸드 베스트 향",
            price:33500
        },
    
        {
            id:1,
            title:"퍼퓸드 핸드앤바디 워시&에멀전 듀오세트",
            imgUrl:"/img/gift2.jpg",
            content:"샌달우드 | 패츌리 | 흙 내음",
            price:74000
        },
    
        {
            id:2,
            title:"바디듀오 FOG",
            imgUrl:"/img/gift3.jpg",
            content:"샤워리바디워시&로션",
            price:68000
        },
    
        {
            id:3,
            title:"손 소독제 트리오(000+FEY9+7)",
            imgUrl:"/img/gift4.jpg",
            content:"손 소독제 세 가지 향",
            price:32000
        }
    
    ]
}
export default choice;